// File: components/LeadCaptureForm.js
import React, { useState } from 'react';
import axios from 'axios';
import "./LeadCaptureForm.css"; // Import the corresponding CSS
import PhoneInput from 'react-phone-number-input/input' 


function getSubdomainFromHref() {
  const url = new URL(window.location.href);
  const hostname = url.hostname;

  // Assuming subdomain is the first part of the hostname
  const parts = hostname.split('.');

  // Check if there is a subdomain (e.g., subdomain.example.com)
  if (parts.length >= 2) {
    return parts[0];
  }

  return ''; // No subdomain found
}

export { getSubdomainFromHref };

const LeadCaptureForm = ({ fhCode, isFromSpecificSite }) => {
  // State for field values and errors
  const [fieldValues, setFieldValues] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    code: isFromSpecificSite ? fhCode : '',
    subscribe: true, // Default checked
  });


  const apiUrl = process.env.REACT_APP_API_URL;

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Handle input value changes
  const handleValueChange = (field, value) => {

    setFieldValues({ ...fieldValues, [field]: value });
  };

  // Clears all errors
  const clearErrors = () => {
    setErrors({});
  };

  // Make an error message for a specific field
  const makeError = (message, fieldKey) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldKey]: message,
    }));
  };

  // Validate form fields
  const validateFields = () => {
    clearErrors();
    let isValid = true;

    const { firstName, lastName, phone, email, code } = fieldValues;

    if (!firstName) {
      makeError('Please enter first name', 'firstName');
      isValid = false;
    } else if (firstName.length > 80) {
      makeError('First name must be less than 80 characters', 'firstName');
      isValid = false;
    }

    if (!lastName) {
      makeError('Please enter last name', 'lastName');
      isValid = false;
    } else if (lastName.length > 80) {
      makeError('Last name must be less than 80 characters', 'lastName');
      isValid = false;
    }

    if (!phone) {
      makeError('Please enter a valid phone number', 'phone');
      isValid = false;
    }

    if (!email) {
      makeError('Please enter a valid email address', 'email');
      isValid = false;
    }

    if (!code) {
      makeError('Please enter a valid funeral home code', 'code');
      isValid = false;
    }

    return isValid;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }

    setLoading(true);
    try {
      const subdomain = getSubdomainFromHref();
      const { firstName, lastName, phone, email, code, subscribe } = fieldValues;

      // Submit to the API
      const response = await axios.post(`${apiUrl}/submitlead`, {
        firstName,
        lastName,
        email,
        phone,
        href: subdomain,
        code,
        subscribe, // Include the subscribe value
      });

      if (response.data.redirectURL) {
        window.location.href = response.data.redirectURL;
      } else {
        alert('An error occurred processing your request, please try again later');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred processing your request, please try again later');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form id="domani-lead-capture-form" className="form-container" onSubmit={handleSubmit}>
      <div>
        <label>NAME  <span>(required)</span></label>
      </div>
      <div className="form-row">
        <div className="form-field">
          <label for="domani-lead-capture-first-name">First Name</label>
          <input
            id="domani-lead-capture-first-name"
            type="text"
            value={fieldValues.firstName}
            onChange={(e) => handleValueChange('firstName', e.target.value)}
          />
          {errors.firstName && <span className="error">{errors.firstName}</span>}
        </div>
        <div className="form-field">
          <label for="domani-lead-capture-last-name">Last Name</label>
          <input
            id="domani-lead-capture-last-name"
            type="text"
            value={fieldValues.lastName}
            onChange={(e) => handleValueChange('lastName', e.target.value)}
          />
          {errors.lastName && <span className="error">{errors.lastName}</span>}
        </div>
      </div>
      <div>
        <label>FUNERAL HOME CODE: <span>(required)</span></label>
        <input
          id="domani-lead-capture-code"
          type="text"
          value={fieldValues.code}
          onChange={(e) => handleValueChange('code', e.target.value)}
        />
        {errors.code && <span className="error">{errors.code}</span>}
      </div>
      <div>
        <label>PHONE <span>(required)</span></label>
        <PhoneInput
          country="US"
          id="domani-lead-capture-phone"
          type="text"
          value={fieldValues.phone}
          onChange={(e) => handleValueChange('phone', e)}
        />
        {errors.phone && <span className="error">{errors.phone}</span>}
      </div>
      <div>
        <label>EMAIL <span>(required)</span></label>
        <input
          id="domani-lead-capture-email"
          type="email"
          value={fieldValues.email}
          onChange={(e) => handleValueChange('email', e.target.value)}
        />
        {errors.email && <span className="error">{errors.email}</span>}
      </div>
      <div>
        <label>
          <input
            id="domani-lead-capture-subscribe"
            type="checkbox"
            checked={fieldValues.subscribe}
            onChange={(e) => handleValueChange('subscribe', e.target.checked)}
          />
          Sign up for news and updates
        </label>
      </div>
      <button type="submit" disabled={loading}>
        {loading ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  );
};

export default LeadCaptureForm;